import _ from 'lodash';

class Mask {
  constructor() {
    this.cache = {};
    this.maskDefinitions = {
      '9': /\d/,
      A: /[a-zA-Z]/,
      '*': /[a-zA-Z0-9]/,
    };
    return (value, mask) => {
      let maskDef = this.processRawMask(mask);
      let alphanumericValue = value.replace(/[^a-z0-9]/gi, '');
      let maskedValue = this.maskValue(alphanumericValue, maskDef);
      return maskedValue;
    };
  }

  processRawMask(mask) {
    if (this.cache[mask]) return this.cache[mask];

    let characterCount = 0;
    let maskCaretMap = [];
    let maskPatterns = [];
    let maskPlaceholder = '';
    let minRequiredLength = 0;

    if (_.isString(mask)) {
      let isOptional = false,
        numberOfOptionalCharacters = 0,
        splitMask = mask.split('');

      splitMask.forEach((chr, i) => {
        if (this.maskDefinitions[chr]) {
          maskCaretMap.push(characterCount);
          maskPlaceholder += this.getPlaceholderChar(i - numberOfOptionalCharacters);
          maskPatterns.push(this.maskDefinitions[chr]);
          characterCount++;
          if (!isOptional) {
            minRequiredLength++;
          }
          isOptional = false;
        } else if (chr === '?') {
          isOptional = true;
          numberOfOptionalCharacters++;
        } else {
          maskPlaceholder += chr;
          characterCount++;
        }
      });
    }
    // Caret position immediately following last position is valid.
    maskCaretMap.push(maskCaretMap.slice().pop() + 1);
    return (this.cache[mask] = { maskCaretMap: maskCaretMap, maskPlaceholder: maskPlaceholder });
  }

  maskValue(unmaskedValue, maskDef) {
    unmaskedValue = unmaskedValue || '';
    let valueMasked = '',
      maskCaretMapCopy = maskDef.maskCaretMap.slice();

    maskDef.maskPlaceholder.split('').forEach((chr, i) => {
      if (unmaskedValue.length && i === maskCaretMapCopy[0]) {
        valueMasked += unmaskedValue.charAt(0) || '_';
        unmaskedValue = unmaskedValue.substr(1);
        maskCaretMapCopy.shift();
      } else {
        valueMasked += chr;
      }
    });
    return valueMasked;
  }

  getPlaceholderChar(i) {
    return '_';
  }
}

export default Mask;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-filters/mask-filter.js